var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6C7.34315 6 6 7.34315 6 9V39C6 40.6569 7.34315 42 9 42H39C40.6569 42 42 40.6569 42 39V9C42 7.34315 40.6569 6 39 6H9ZM37.8755 8C38.0712 8 38.2587 8.08152 38.3891 8.22554C38.5223 8.36957 38.5875 8.5625 38.5685 8.75815L36.1228 36.1848C36.0956 36.4728 35.8973 36.712 35.6201 36.7935L24.4734 39.9728C24.4109 39.9918 24.3484 40 24.2831 40C24.2179 40 24.1527 39.9918 24.0929 39.9728L12.9543 36.7935C12.6772 36.712 12.4761 36.4728 12.4516 36.1848L10.0032 8.75815C9.98422 8.5625 10.0494 8.36957 10.1826 8.22554C10.313 8.08152 10.5005 8 10.6962 8H37.8755ZM19.4407 17.6821H32.5277L32.8293 14.2989H15.7451L16.6663 24.5978H28.5223L28.1174 29.0761L24.3212 29.8859L20.4543 29.0761L20.3076 27.4212H16.919L17.2967 31.6848L24.2125 33.7799L24.2804 33.8016L31.2777 31.6875L32.2125 21.2228H19.7532L19.4407 17.6821Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.e0ea844f137b9011569249f3ce2c2dbf.svg";
export { ForwardRef as ReactComponent };